import type { TutorPaymentPoliciesData } from '@entities/tutor'

import { useCommonStore } from '@shared/model'
import { useAdminRoutes } from '@shared/lib/routes'

import { usePaymentPoliciesStore } from '../../model/payment-policy/store'

interface PaymentPoliciesApiOptions {
  tutorId: string | number
  onStart?: () => void
  onSuccess?: () => void
  onError?: (err: unknown) => void
  onFinish?: () => void
}

export const usePaymentPoliciesApi = async (options: PaymentPoliciesApiOptions): Promise<TutorPaymentPoliciesData | null> => {
  const { $axios } = useNuxtApp()

  const url = useAdminRoutes('admin.tutors.payment-policies', { tutor_id: options.tutorId })

  const paymentPoliciesStore = usePaymentPoliciesStore()
  const commonStore = useCommonStore()

  options.onStart?.()
  commonStore.setLoading(true)

  try {
    const { data } = await $axios.get<{ data: TutorPaymentPoliciesData }>(url!)
    const policies: TutorPaymentPoliciesData | null = data.data || null

    paymentPoliciesStore.setTutorPaymentPolicies(policies)
    commonStore.setLoading(false)

    options.onSuccess?.()

    return policies
  } catch (err: unknown) {
    console.error(err)
    commonStore.setLoading(false)
    options.onError?.(err)

    return null
  } finally {
    options.onFinish?.()
  }
}
